<template>
	<div class="ztbox">
		<div class="ztone flex spa-bet">
			<div class="ztone-item" style="width:240px;">
				<div class="ztone-item-header">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>数据总览</span>
				</div>
				<div class="ztone-item-box">
					<div class="ztone-item-box-item">
						<img src="@/assets/images/bigData/zu1.png" class="ztone-item-box-item-img" alt="">
						<div class="ztone-item-box-item-sj">
							<p class="ztone-item-box-item-sj-num">1个</p>
							<p class="ztone-item-box-item-sj-text">思政工作室</p>
						</div>
					</div>
					<img src="@/assets/images/bigData/zuline.png" class="ztone-item-box-img" alt="">
					<div class="ztone-item-box-item">
						<img src="@/assets/images/bigData/zu2.png" class="ztone-item-box-item-img" alt="">
						<div class="ztone-item-box-item-sj">
							<p class="ztone-item-box-item-sj-num">9个</p>
							<p class="ztone-item-box-item-sj-text">特色文化育人品牌</p>
						</div>
					</div>
					<img src="@/assets/images/bigData/zuline.png" class="ztone-item-box-img" alt="">
					<div class="ztone-item-box-item">
						<img src="@/assets/images/bigData/zu3.png" class="ztone-item-box-item-img" alt="">
						<div class="ztone-item-box-item-sj">
							<p class="ztone-item-box-item-sj-num">75个</p>
							<p class="ztone-item-box-item-sj-text">思政微课</p>
						</div>
					</div>
				</div>
			</div>
			 <div class="ztone-item" style="width:calc((100% - 270px)/3);">
				<div class="ztone-item-header ztone-item-headers">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>思政工作室</span>
				</div>
				<div class="ztone-item-box" ref="studio" id="studio">
				</div>
			</div> 
			 <div class="ztone-item" style="width:calc((100% - 270px)/3);">
				<div class="ztone-item-header ztone-item-headers">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>特色文化育人品牌</span>
				</div>
				<div class="ztone-item-box" ref="brand" id="brand">
				</div>
			</div> 
			 <div class="ztone-item" style="width:calc((100% - 270px)/3);">
				<div class="ztone-item-header ztone-item-headers">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>思政微课</span>
				</div>
				<div class="ztone-item-box" id="course" ref="course">
				</div>
			</div> 
			<!-- <div class="ztone-item" style="width:calc((100% - 610px)/3);">
				<div class="ztone-item-header ztone-item-headers">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>项目资金</span>
				</div>
				<div class="ztone-item-box">
					<div class="ztone-item-box-list flex spa-bet">
						<div class="ztone-item-box-list-item">预算资金：<span>150</span>万元</div>
						<div class="ztone-item-box-list-item">实际资金：<span>120</span>万元</div>
					</div>
					<div class="ztone-item-box-box" style="height:216px;" ref="totalManey">

					</div>
				</div>
			</div> -->
			<!-- <div class="ztone-item" style="width:calc((100% - 610px)/3);">
				<div class="ztone-item-header ztone-item-headers">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>预算资金来源</span>
				</div>
				<div class="ztone-item-box" ref="achievements" id="achievements">
				</div>
			</div> -->
			<!-- <div class="ztone-item" style="width:330px;">
				<div class="ztone-item-header ztone-item-headers">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>实际使用资金</span>
				</div>
				<div class="ztone-item-box">
					<div class="ztone-item-box-zjitem flex spa-bet align-center">
						<span>省资金使用率</span>
						<span class="ztone-item-box-zjitem-per">100%</span>
					</div>
					<div class="ztone-item-box-zjitem flex spa-bet align-center">
						<span>地方资金使用率</span>
						<span class="ztone-item-box-zjitem-per">100%</span>
					</div>
					<div class="ztone-item-box-zjitem flex spa-bet align-center">
						<span>学校自筹资金使用率</span>
						<span class="ztone-item-box-zjitem-per">100%</span>
					</div>
					<div class="ztone-item-box-zjitem flex spa-bet align-center">
						<span>其他资金使用率</span>
						<span class="ztone-item-box-zjitem-per">100%</span>
					</div>
				</div>
			</div> -->
			<!-- <div class="ztone-item" style="width:calc((100% - 610px)/3);">
				<div class="ztone-item-header ztone-item-headerss">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>项目资金使用</span>
					<div class="ztpos">
						<a-select v-model="year" style="width: 160px; margin-left: 10px;" @change="handleChange"
							:dropdownClassName="'customClass'">
							<a-select-option value="思政工作室">思政工作室</a-select-option>
							<a-select-option value="特色文化育人品牌">特色文化育人品牌</a-select-option>
							<a-select-option value="思政微课">思政微课</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="ztone-item-box" ref="maneyUse">

				</div>
			</div> -->
		</div>
		<div class="ztbt flex spa-bet align-center">
			<img class="ztimg" src="@/assets/images/bigData/obg3.png" alt="" />
			<!-- <div class="zttitle">思政教育工作室</div> -->
			<div class="zttitle">晋沃思政教育工作室</div>
			<img class="ztimg" src="@/assets/images/bigData/obg4.png" alt="">
		</div>
		<!-- <div class="ztlist">
			<div class="ztitem" :class="num == index ? 'ztactive' : ''" v-for="(item, index) in szlist"
				@click="tabsz(index)" :key="index" :style="item.name.length > 20 ? 'line-height:26px;' : ''">
				{{ item.name }}
			</div>
		</div> -->
		<div class="zttwo flex spa-bet">
			<div class="zttwoitem" style="width:30%;">
				<div class="ztleftone">
					<div class="ztheader">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>工作室基本信息</span>
					</div>
					<div class="ztboxs" style="height:290px;">
						<div class="twoleftitem flex spa-bet align-center">
							<div class="twoleftone">
								<img src="@/assets/images/bigData/obg15.png" style="width:25px;height:22px;" alt="" />
								<p>工作室所属部门</p>
							</div>
							<p>德育研究中心 </p>
						</div>
						<div class="twoleftitem flex spa-bet align-center">
							<div class="twoleftone">
								<img src="@/assets/images/bigData/obg20.png" style="width:25px;height:22px;" alt="" />
								<p>工作室类别</p>
							</div>
							<p>校级/省级(2021)</p>
						</div>
						<div class="twoleftmiddle flex spa-bet align-center">
							<div class="twoleftitem flex spa-bet align-center" style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg16.png" style="width:22px;height:22px;"
										alt="" />
									<p>建设日期</p>
								</div>
								<p>2021年9月 </p>
							</div>
							<div class="twoleftitem flex spa-bet align-center" style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg17.png" style="width:21px;height:22px;"
										alt="" />
									<p>负责人</p>
								</div>
								<p>申玉萍 </p>
							</div>
						</div>
						<div class="twoleftmiddle flex spa-bet align-center">
							<div class="twoleftitem flex spa-bet align-center" style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg18.png" style="width:20px;height:22px;"
										alt="" />
									<p>工作室地点</p>
								</div>
								<p>匠心楼二楼</p>
							</div>
							<div class="twoleftitem flex spa-bet align-center" style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg19.png" style="width:26px;height:22px;"
										alt="" />
									<p>场所面积</p>
								</div>
								<p>XXX平方米</p>
							</div>
						</div>
						<!-- <div class="twoleftmiddle flex spa-bet align-center"> 
						<div class="twoleftitem flex spa-bet align-center" style="width:calc((100% - 10px)/2)">
							<div class="twoleftone">
								<img src="@/assets/images/bigData/obg20.png" style="width:22px;height:22px;" alt="" />
								<p>被服务者好评率</p>
							</div>
							<p>98%</p>
						</div>
						<div class="twoleftitem flex spa-bet align-center" style="width:calc((100% - 10px)/2)">
							<div class="twoleftone">
								<img src="@/assets/images/bigData/obg21.png" style="width:22px;height:22px;" alt="" />
								<p>合作单位数</p>
							</div>
							<p>2</p>
						</div>		
					</div> -->
					</div>
				</div>
				<div class="ztleftone" style="height:350px;">
					<div class="ztheader">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>工作室团队(12人)</span>
					</div>
					<div class="ztboxs" style="height:300px;">
						<div class="twoleftems">
							<div class="twoleft-one">
								<img src="@/assets/images/bigData/xl.png" alt="">
								<p>学历</p>
							</div>
							<div class="twoleft-item">
								<p class="twoleft-item-num">0人</p>
								<p class="twoleft-item-text">博士</p>
							</div>
							<div class="twoleft-line"></div>
							<div class="twoleft-item">
								<p class="twoleft-item-num">1人</p>
								<p class="twoleft-item-text">硕士</p>
							</div>
							<div class="twoleft-line"></div>
							<div class="twoleft-item">
								<p class="twoleft-item-num">10人</p>
								<p class="twoleft-item-text">本科</p>
							</div>
						</div>
						<div class="twoleftems">
							<div class="twoleft-one">
								<img src="@/assets/images/bigData/zc.png"
									style="width:15px;height:23px;margin-right:11px;" alt="">
								<p>职称</p>
							</div>
							<div class="twoleft-item" style="width:calc((100% - 95px)/4)">
								<p class="twoleft-item-num">0人</p>
								<p class="twoleft-item-text">正高级</p>
							</div>
							<div class="twoleft-line"></div>
							<div class="twoleft-item" style="width:calc((100% - 95px)/4)">
								<p class="twoleft-item-num">3人</p>
								<p class="twoleft-item-text">副高级</p>
							</div>
							<div class="twoleft-line"></div>
							<div class="twoleft-item" style="width:calc((100% - 95px)/4)">
								<p class="twoleft-item-num">8人</p>
								<p class="twoleft-item-text">中级</p>
							</div>
							<div class="twoleft-line"></div>
							<div class="twoleft-item" style="width:calc((100% - 95px)/4)">
								<p class="twoleft-item-num">1人</p>
								<p class="twoleft-item-text">初级</p>
							</div>
						</div>
						<div class="twoleftems" style="height:116px;align-items:flex-start;">
							<div class="twoleft-one" style="height:116px;flex-direction: column;">
								<img src="@/assets/images/bigData/cy.png"
									style="width:26px;height:23px;margin-bottom:8px;" alt="">
								<p>成员结构</p>
							</div>
							<div class="twoleft-zt">
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">3人</p>
									<p class="twoleft-item-text">思政教师</p>
								</div>
								<div class="twoleft-line"></div>
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">2人</p>
									<p class="twoleft-item-text">专业课教师</p>
								</div>
								<div class="twoleft-line"></div>
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">1人</p>
									<p class="twoleft-item-text">大国工匠</p>
								</div>
								<div class="twoleft-line"></div>
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">2人</p>
									<p class="twoleft-item-text">党群管理</p>
								</div>
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">1人</p>
									<p class="twoleft-item-text">教学管理</p>
								</div>
								<div class="twoleft-line"></div>
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">0人</p>
									<p class="twoleft-item-text">学生管理</p>
								</div>
								<div class="twoleft-line"></div>
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">1人</p>
									<p class="twoleft-item-text">教辅人员</p>
								</div>
								<div class="twoleft-line"></div>
								<div class="twoleft-item" style="width:calc((100% - 4px)/4)">
									<p class="twoleft-item-num">1人</p>
									<p class="twoleft-item-text">校外辅导员</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="ztleftone" style="margin-bottom:0px;height:146px;">
					<div class="ztheader ztheaders">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>工作室活动经费</span>
						<div class="ztpos">
							<a-select v-model="years" style="width: 160px; margin-left: 10px;" @change="handleChanges"
								:dropdownClassName="'customClass'">
								<a-select-option value="全部经费">全部经费</a-select-option>
							</a-select>
						</div>
					</div>
					<div class="ztboxs" style="height:100px;">
						<div class="twoleftmiddle flex spa-bet align-center" style="height:76px;">
							<div class="twoleftitem twoleftitems flex spa-bet align-center"
								style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<!-- <img src="@/assets/images/bigData/obg20.png" style="width:22px;height:22px;" alt="" /> -->
									<p>收入</p>
								</div>
								<p>1000万元</p>
							</div>
							<div class="twoleftitem twoleftitems flex spa-bet align-center"
								style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<!-- <img src="@/assets/images/bigData/obg21.png" style="width:22px;height:22px;" alt="" /> -->
									<p>支出</p>
								</div>
								<p>1000万元</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="zttwoitem" style="width:26%;">
				<div class="ztheader">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>思政课程与课程思政大格局</span>
				</div>
				<div class="ztboxs" style="height:810px;">
					<div class="ztmiddone">
						<!-- style="width:calc(100% - 210px);margin-right:10px;" -->
						<div class="ztmiddoneitem">
							<div class="ztbt-two" style="margin: 6px 0;">
								<span>思政课程开展</span>
								<img src="@/assets/images/bigData/obg22.png" alt="">
							</div>
							<div class="ztmiddelthree">
								<div class="ztmiddelthree-item">
									<p><span class="ztmiddelthree-num">23</span>门</p>
									<p class="ztmiddelthree-text">思政精品课程</p>
								</div>
								<div class="ztmiddelthree-item">
									<p><span class="ztmiddelthree-num">15</span>个</p>
									<p class="ztmiddelthree-text">思政示范课程</p>
								</div>
								<div class="ztmiddelthree-item">
									<p><span class="ztmiddelthree-num">69</span>个</p>
									<p class="ztmiddelthree-text">思政教育系列</p>
								</div>
							</div>
							<div class="ztbt-two" style="margin: 6px 0;">
								<span>课程思政开展</span>
								<img src="@/assets/images/bigData/obg22.png" alt="">
							</div>
							<div class="ztmiddelthree" style="height:134px;">
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">29</span>个
									</div>
									<p class="everytext">精品课</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">35</span>个
									</div>
									<p class="everytext">金课</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">35</span>个
									</div>
									<p class="everytext">示范课堂</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">75</span>个
									</div>
									<p class="everytext">课堂革命教育案例</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">75</span>个
									</div>
									<p class="everytext">课堂思政教育案例</p>
								</div>
							</div>
						</div>
						<!--  -->
					</div>
					<div class="ztmiddone" style="height:260px;">
						<div class="ztmiddoneitem">
							<div class="ztbt-two" style="margin: 6px 0;">
								<span style="min-width:170px;">思政课程参加比赛获奖</span>
								<img style="width:calc(100% - 170px)" src="@/assets/images/bigData/obg22.png" alt="">
							</div>
							<div class="ztmiddelthree" style="height:112px;">
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">29</span>个
									</div>
									<p class="everytext">校级</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">35</span>个
									</div>
									<p class="everytext">市级</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">35</span>个
									</div>
									<p class="everytext">省级</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">75</span>个
									</div>
									<p class="everytext">国家级</p>
								</div>
							</div>
							<div class="ztmiddelthree" style="height:100px;">
								<div class="ztmiddoneitem ztbg" style="width:100%;">
									<div class="ztbg-item">
										<img src="@/assets/images/bigData/obg26.png" class="ztbg-img" alt="">
										<div class="ztbg-right">
											<p><span class="ztbg-rightnum">56</span>次</p>
											<p>思政微课</p>
										</div>
									</div>
									<div class="ztbg-item">
										<img src="@/assets/images/bigData/obg26.png" class="ztbg-img" alt="">
										<div class="ztbg-right">
											<p><span class="ztbg-rightnum">56</span>次</p>
											<p>思政大教研活动</p>
										</div>
									</div>
									<!-- <div class="ztbg-item">
											<img src="@/assets/images/bigData/obg26.png" class="ztbg-img" alt="">
											<div class="ztbg-right">
												<p><span class="ztbg-rightnum">23</span>次</p>
												<p>思政教研与研究</p>
											</div>
										</div>
										<div class="ztbg-item">
											<img src="@/assets/images/bigData/obg26.png" class="ztbg-img" alt="">
											<div class="ztbg-right">
												<p><span class="ztbg-rightnum">26</span>次</p>
												<p>思政育人实践活动</p>
											</div>
										</div> -->
								</div>
							</div>
						</div>
					</div>
					<div class="ztmiddone" style="height:260px;">
						<!-- style="width:calc(100% - 210px);margin-right:10px;" -->
						<div class="ztmiddoneitem">
							<div class="ztbt-two" style="margin: 6px 0;">
								<span style="min-width:80px;">科研情况</span>
								<img src="@/assets/images/bigData/obg22.png" alt="">
							</div>
							<div class="ztmiddelthree" style="height:128px;">
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">26</span>个
									</div>
									<p class="everytext">校级科研或教改项目</p>
								</div>
								<div class="everyitem">
									<div class="everyimg">
										<span class="everynum">35</span>个
									</div>
									<p class="everytext">省级文章</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="zttwoitem" style="width:20%;">
				<div class="ztheader">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>思政实践基地</span>
				</div>
				<div class="ztboxs" style="height:410px;">
					<div class="ztmiddone">

						<div class="ztboxs-left">
							<div class="ztboxs-left-item">
								<p><span class="ztim">2</span>个</p>
								<div class="ztboxs-left-img">校内基地</div>
							</div>
							<div class="ztboxs-left-item">
								<p><span class="ztim">5</span>个</p>
								<div class="ztboxs-left-img">校外基地</div>

							</div>
							<div class="ztboxs-left-item">
								<p><span class="ztim">15</span>个</p>
								<div class="ztboxs-left-img">线上基地</div>
							</div>
							<div class="ztboxs-left-item">
								<p><span class="ztim">3</span>个</p>
								<div class="ztboxs-left-img">线下基地</div>
							</div>
						</div>
						<div class="ztboxs-right" ref="zxt"></div>

					</div>
				</div>
				<div class="ztmiddone" style="height:400px;">

					<div class="ztmiddoneitem" style="width:100%;height:100%;">
						<div class="ztheader">
							<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
							<span>团队建设</span>
							<!-- <img src="@/assets/images/bigData/obg22.png" alt=""> -->
						</div>
						<div class="ztboxs" style="height:343px;padding:0px 6px;">
							<div class="zttditem">
								<p>青年教师培养培训数量</p>
								<p><span class="ztim">35</span>人</p>
							</div>
							<div class="zttditem">
								<p>青年教师教学基本功比赛</p>
								<p><span class="ztim">10</span>人</p>
							</div>
							<div class="zttditem">
								<p>教学能力大赛</p>
								<p><span class="ztim">12</span>人</p>
							</div>
							<div class="zttditem">
								<p>班主任能力大赛</p>
								<p><span class="ztim">11</span>人</p>
							</div>
							<div class="zttditem">
								<p>思想政治工作研讨会每周</p>
								<p><span class="ztim">1</span>次</p>
							</div>
							<div class="zttditem">
								<p>校级以上科研课题研究数量</p>
								<p><span class="ztim">3</span>个</p>
							</div>
							<div class="zttditem">
								<p>思政课题研究</p>
								<p><span class="ztim">1</span>个</p>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="zttwoitem" style="width:22%;">
				<div class="ztheader ">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>教研周期</span>

				</div>
				<div class="ztboxs">
					<div class="ztrightone" id="jyzq"></div>

				</div>
				<div class="ztheader">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>工作室成果及影响力</span>
				</div>
				<div class="ztboxs">

					<div class="tablist">
						<div class="tabitem" :class="num2 == index ? 'tabactive' : ''" v-for="(item, index) in sjlist"
							:key="index" @click="tabitem(index)">{{ item.name }}<span class="tabnum">({{ item.num
							}})</span>
						</div>
						<!-- <div class="tabitem">培育品牌<span class="tabnum">(2个)</span></div> -->
					</div>
					<div class="ztrightone" v-if="num2 == '0'"
						style="height:322px;overflow:hidden;overflow-y:auto;padding: 6px;">

						<div class="ztrightoneitem">
							<div class="ztrightoneleft">
								<img src="@/assets/images/bigData/obg29.png" alt="">
								<p>获得全国职业院校教学能力大赛三等奖</p>
							</div>
							<p><span class="ztim">4</span>名</p>
						</div>
						<div class="ztrightoneitem">
							<div class="ztrightoneleft">
								<img src="@/assets/images/bigData/obg29.png" alt="">
								<p>获得山西省职业院校教学能力大赛二等奖</p>
							</div>
							<p><span class="ztim">16</span>名</p>
						</div>
						<div class="ztrightoneitem">
							<div class="ztrightoneleft">
								<img src="@/assets/images/bigData/obg29.png" alt="">
								<p>获得山西省职业院校教学能力大赛三等奖</p>
							</div>
							<p><span class="ztim">8</span>名</p>
						</div>
						<div class="ztrightoneitem">
							<div class="ztrightoneleft">
								<img src="@/assets/images/bigData/obg29.png" alt="">
								<p>获得山西省职业院校班主任能力大赛二等奖</p>
							</div>
							<p><span class="ztim">10</span>名</p>
						</div>
						<div class="ztrightoneitem">
							<div class="ztrightoneleft">
								<img src="@/assets/images/bigData/obg29.png" alt="">
								<p>获得山西省职业院校班主任能力大赛三等奖</p>
							</div>
							<p><span class="ztim">6</span>名</p>
						</div>
						<div class="ztrightoneitem">
							<div class="ztrightoneleft">
								<img src="@/assets/images/bigData/obg29.png" alt="">
								<p>获得临汾市职业院校教学能力大赛一等奖</p>
							</div>
							<p><span class="ztim">16</span>名</p>
						</div>
					</div>
					<div class="ztrightone" v-if="num2 == '1'"
						style="height:322px;overflow:hidden;overflow-y:auto;padding: 6px;">
						<div class="ztrightone-twoitem" v-for="item in 8" :key="item">
							<img src="@/assets/images/bigData/obg46.png" alt="">
							<p>培育品牌名</p>
						</div>
					</div>
					<div class="ztrightone"
						style="height: 84px;margin-top: 6px;display: flex;justify-content: space-around;">
						<div style="text-align: center;width: 40%;">
							<div>
								<span style="color: #ffd70e;font-weight: bold;">16</span>
								<span>次</span>
							</div>
							<div>
								被省级或国家级媒体报道次数
							</div>
						</div>
						<div style="text-align: center;width: 40%;">
							<div>
								<span style="color: #ffd70e;font-weight: bold;">16</span>
								<span>个</span>
							</div>
							<div>
								前来交流学习的省内外同类院校数量
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ztbt flex spa-bet align-center">
			<img class="ztimg" src="@/assets/images/bigData/obg3.png" alt="" />
			<div class="zttitle">特色文化育人品牌</div>
			<img class="ztimg" src="@/assets/images/bigData/obg4.png" alt="">
		</div>
		<div class="ztlist">
			<div class="ztitem" :class="num1 == index ? 'ztactive' : ''" v-for="(item, index) in pplist"
				@click="tabpp(index)" :key="index" :style="item.name.length > 20 ? 'line-height:26px;' : ''">
				{{ item.name }}
			</div>
		</div>
		<div class="zttwo flex spa-bet">
			<div class="zttwoitem" style="width:30%;">
				<div class="ztleftone">
					<div class="ztheader">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>品牌基本信息</span>
					</div>
					<div class="ztboxs" style="height:290px;">
						<div class="twoleftitem flex spa-bet align-center twoleftcolor">
							<div class="twoleftone">
								<img src="@/assets/images/bigData/obg9.png" style="width:24px;height:24px;" alt="" />
								<p>隶属部门</p>
							</div>
							<p>德育研究中心 </p>
						</div>
						<div class="twoleftmiddle flex spa-bet align-center">
							<div class="twoleftitem flex spa-bet align-center twoleftcolor"
								style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg10.png" style="width:23px;height:24px;"
										alt="" />
									<p>建设日期</p>
								</div>
								<p>2021年9月 </p>
							</div>
							<div class="twoleftitem flex spa-bet align-center twoleftcolor"
								style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg11.png" style="width:24px;height:24px;"
										alt="" />
									<p>负责人</p>
								</div>
								<p>翟建华 </p>
							</div>
						</div>
						<div class="twoleftmiddle flex spa-bet align-center twoleftcolor">
							<div class="twoleftitem flex spa-bet align-center" style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg12.png" style="width:32px;height:24px;"
										alt="" />
									<p>团队成员</p>
								</div>
								<p>5人</p>
							</div>
							<div class="twoleftitem flex spa-bet align-center twoleftcolor"
								style="width:calc((100% - 10px)/2)">
								<div class="twoleftone">
									<img src="@/assets/images/bigData/obg13.png" style="width:26px;height:26px;"
										alt="" />
									<p>品牌层级</p>
								</div>
								<p>省级/专业</p>
							</div>
						</div>
						<div class="twoleftitem flex spa-bet align-center twoleftcolor">
							<div class="twoleftone">
								<img src="@/assets/images/bigData/obg14.png" style="width:24px;height:24px;" alt="" />
								<p>认定年份</p>
							</div>
							<p>2021年</p>
						</div>
					</div>
				</div>
				<div class="ztleftone" style="height:190px;">
					<div class="ztheader">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>品牌内涵</span>
					</div>
					<div class="ztboxs"
						style="height:134px;display: flex;flex-wrap: wrap;padding: 12px;overflow-y: auto;">
						<div class="brand-item" v-for="item in brandConnotationList">
							{{ item }}
						</div>
					</div>
				</div>
				<div class="ztleftone" style="height:150px;">
					<div class="ztheader">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>品牌分类</span>
					</div>
					<div class="ztboxs"
						style="height:80px;display: flex;flex-wrap: wrap;padding: 18px 12px;overflow-y: auto;">
						<div class="brand-item" v-for="item in brandClassifyList">
							{{ item }}
						</div>
					</div>
				</div>
				<div class="ztleftone" style="margin-bottom:0px;height:120px;">
					<div class="ztheader ztheaders">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>品牌活动经费</span>
						<div class="ztpos">
							<a-select v-model="years" style="width: 160px; margin-left: 10px;" @change="handleChanges"
								:dropdownClassName="'customClass'">
								<a-select-option value="全部经费">全部经费</a-select-option>
							</a-select>
						</div>
					</div>
					<div class="ztboxs"
						style="height:100px;display: flex;justify-content: space-around;padding: 24px 12px;">
						<div class="money-item" v-for="(item, index) in expenditureList">
							<span v-if="index == '0'">收入：</span>
							<span v-if="index == '1'">支出：</span>
							<span class="money-num">{{ item.money }}</span>
							<span>万元</span>
						</div>
					</div>
				</div>
			</div>

			<div class="zttwoitem" style="width:23%;">
				<div class="ztheader">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>品牌活动开展情况</span>
				</div>
				<div class="ztboxs" style="height:810px;">
					<div class="ztmiddone" style="margin-bottom:10px;">
						<div class="ztbt-two">
							<span style="min-width:100px;">课程育人情况</span>
							<img src="@/assets/images/bigData/obg22.png" alt="">
						</div>
						<div class="ztmiddoneitem ztbg" style="width:100%;background: transparent;">
							<div class="ztbg-item">
								<img src="@/assets/images/bigData/obg26.png" class="ztbg-img" alt="">
								<div class="ztbg-right">
									<p><span class="ztbg-rightnum">2</span>门</p>
									<p>校本课程</p>
								</div>
							</div>
							<div class="ztbg-item">
								<img src="@/assets/images/bigData/obg26.png" class="ztbg-img" alt="">
								<div class="ztbg-right">
									<p><span class="ztbg-rightnum">152</span>个</p>
									<p>校本建设资源</p>
								</div>
							</div>
						</div>
					</div>
					<div class="ztmiddone" style="margin-bottom:10px;height:280px;">
						<div class="ztbt-two">
							<span style="min-width:180px;">网络德育阵地建设情况</span>
							<img src="@/assets/images/bigData/obg22.png" alt="">
						</div>
						<div class="flex spa-aro align-center" style="width:100%;height:30px;overflow: hidden;">
							<div style="color:#05D6FF">平台名：XXXXXX平台</div>
							<div style="color:#05D6FF">网址：http://XXX.com</div>
						</div>
						<div class="ztmiddoneitem ztbg" style="width:100%;height:230px;" id="jsqk">

						</div>
					</div>
					<div class="ztmiddone" style="margin-bottom:0px;height:370px;">
						<div class="ztbt-two">
							<span style="min-width:100px;">其他方面情况</span>
							<img src="@/assets/images/bigData/obg22.png" alt="">
						</div>
						<div class="ztmiddoneitem ztbg" style="width:100%;height:350px;" id="ppqk">

						</div>
					</div>
				</div>
			</div>
			<div class="zttwoitem" style="width:23%;">
				<div class="ztheader">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>思政育人产品</span>
				</div>
				<div class="ztboxs" style="height:810px;">
					<div class="ztmiddone" style="margin-bottom:0px;">
						<div class="ztbt-two">
							<span style="min-width:80px;">校本读本</span>
							<img src="@/assets/images/bigData/obg22.png" alt="">
						</div>
						<div class="ztmiddoneitem ztbg" style="width:100%;background: transparent;">
							<div class="ztbg-item ztbg-items">
								<div class="ztbg-right ztbg-rights">
									<p><span class="ztbg-rightnum">2</span>门</p>
									<p>校本读本</p>
								</div>
							</div>
							<div class="ztbg-item ztbg-items">
								<div class="ztbg-right ztbg-rights">
									<p><span class="ztbg-rightnum">2</span>门</p>
									<p>校本读本</p>
								</div>
							</div>
							<div class="ztbg-item ztbg-items">
								<div class="ztbg-right ztbg-rights">
									<p><span class="ztbg-rightnum">2</span>门</p>
									<p>校本读本</p>
								</div>
							</div>
						</div>
						<div class="twoleftitem flex spa-bet align-center">
							<div class="twoleftone">
								<img src="@/assets/images/bigData/obg20.png" style="width:25px;height:22px;" alt="" />
								<p>育人模式</p>
							</div>
							<p>xxxxx模式</p>
						</div>
					</div>
					<div class="ztmiddone" style="margin-bottom:10px;height:288px;">
						<div class="ztbt-two">
							<span style="min-width:132px;">数字资源建设情况</span>
							<img src="@/assets/images/bigData/obg22.png" alt="">
						</div>
						<div class="ztmiddoneitem ztbg" style="width:100%;height:262px;background: transparent;"
							id="szzyjsqk">

						</div>
					</div>
					<div class="ztmiddone" style="margin-bottom:10px;height:150px;">
						<div class="ztbt-two">
							<span style="min-width:132px;">数字资源建设情况</span>
							<img src="@/assets/images/bigData/obg22.png" alt="">
						</div>
						<!-- background: transparent; -->
						<div class="ztmiddoneitem ztbg" style="width:100%;height:110px;">
							<div class="ztboxs-left">
								<div class="ztboxs-left-item" style="width:30%;">
									<p style="text-align: center;width:84px;"><span class="ztim">158</span>个</p>
									<div class="ztboxs-left-img">教改项目</div>
								</div>
								<div class="ztboxs-left-item" style="width:30%;">
									<p style="text-align: center;width:84px;"><span class="ztim">155</span>个</p>
									<div class="ztboxs-left-img">课程申报</div>

								</div>
								<div class="ztboxs-left-item" style="width:30%;">
									<p style="text-align: center;width:84px;"><span class="ztim">154</span>个</p>
									<div class="ztboxs-left-img">教学成果</div>
								</div>
							</div>
						</div>
					</div>
					<div class="ztmiddone" style="margin-bottom:0px;height:150px;">
						<div class="ztbt-two">
							<span style="min-width:165px;">教师参与品牌建设情况</span>
							<img src="@/assets/images/bigData/obg22.png" alt="">
						</div>
						<!-- background: transparent; -->
						<div class="ztmiddoneitem ztbg" style="width:100%;height:110px;">
							<div class="ztboxs-left">
								<div class="ztboxs-left-item" style="width:30%;">
									<p style="text-align: center;width:84px;"><span class="ztim">2</span>个</p>
									<div class="ztboxs-left-img">教改项目</div>
								</div>
								<div class="ztboxs-left-item" style="width:30%;">
									<p style="text-align: center;width:84px;"><span class="ztim">5</span>个</p>
									<div class="ztboxs-left-img">课程申报</div>

								</div>
								<div class="ztboxs-left-item" style="width:30%;">
									<p style="text-align: center;width:84px;"><span class="ztim">15</span>个</p>
									<div class="ztboxs-left-img">教学成果</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="zttwoitem" style="width:22%;">
				<div class="ztheader">
					<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
					<span>品牌影响力</span>
				</div>
				<div class="ztboxs" style="height:810px;">
					<div class="ztbt-two">
						<span style="min-width:100px;">品牌活动情况</span>
						<img src="@/assets/images/bigData/obg22.png" alt="">
					</div>
					<div class="ztmiddoneitem" style="height:480px;">
						<div class="xxitem">
							<div class="xximg">178篇</div>
							<p>发文数量</p>
						</div>
						<div class="xxitem">
							<div class="xximg">8579人次</div>
							<p>点击量</p>
						</div>
						<div class="xxitem">
							<div class="xximg">879人</div>
							<p>关注人数</p>
						</div>
						<div class="xxitem">
							<div class="xximg">2个</div>
							<p>宣传载体</p>
						</div>
						<div class="xxitem">
							<div class="xximg">9%</div>
							<p>品牌熟知度</p>
						</div>
						<div class="xxitem">
							<div class="xximg">85%</div>
							<p>好评率</p>
						</div>
						<div class="xxitem">
							<div class="xximg">60%</div>
							<p>教师参与率</p>
						</div>
						<div class="xxitem">
							<div class="xximg">45%</div>
							<p>学生参与率</p>
						</div>
						<div class="xxitem">
							<div class="xximg">1个</div>
							<p>国家级教学成果奖</p>
						</div>
						<div class="xxitem">
							<div class="xximg">5个</div>
							<p>省级教学成果奖</p>
						</div>
						<div class="xxitem">
							<div class="xximg">15个</div>
							<p>品牌成果获得荣誉</p>
						</div>
						<div class="xxitem">
							<div class="xximg">4次</div>
							<p>院校交流学习次数</p>
						</div>
					</div>
					<div class="ztbt-two">
						<span style="min-width:100px;">教学成果奖</span>
						<img src="@/assets/images/bigData/obg22.png" alt="">
					</div>
					<div class="zt-around" style="height:40px;">
						<div class="zt-around-text" :class="sl == index ? 'zt-around-active' : ''"
							v-for="(item, index) in sz" @click="getcg(index)"">
						   {{ item }}
						</div>
						
					</div>
					<div class=" zt-around" style="height:190px;">
							<div class="zt-around-item">
								<div class="zt-around-two">5</div>
								<div class="zt-around-one">教学成果奖</div>
								<div class="zt-around-one" style="margin-top:0px;">（国家级）</div>
							</div>
							<div class="zt-around-item">
								<div class="zt-around-two">5</div>
								<div class="zt-around-one">教学成果奖</div>
								<div class="zt-around-one" style="margin-top:0px;">（省级）</div>
							</div>
							<div class="zt-around-item">
								<div class="zt-around-two">5</div>
								<div class="zt-around-one">教学成果奖</div>
								<div class="zt-around-one" style="margin-top:0px;">（市级）</div>
							</div>
							<!-- <div class="zt-around-item">
							<div class="zt-around-one">微课开发</div>
							<div class="zt-around-two">75个</div>
						</div> -->
						</div>

					</div>



				</div>
			</div>
			<div class="ztbt flex spa-bet align-center">
				<img class="ztimg" src="@/assets/images/bigData/obg3.png" alt="" />
				<div class="zttitle">思政微课</div>
				<img class="ztimg" src="@/assets/images/bigData/obg4.png" alt="">
			</div>
			<div class="flex spa-bet wkbox">
				<div class="wkitem" style="width:230px;">
					<div class="wkitem-item">
						<p>微课数量</p>
						<p><span class="ztim">125</span>个</p>
					</div>
					<div class="wkitem-item">
						<p>参与教师</p>
						<p><span class="ztim">152</span>人</p>
					</div>
					<div class="wkitem-item">
						<p>覆盖课程</p>
						<p><span class="ztim">56</span>门</p>
					</div>
					<div class="wkitem-item">
						<p>学习人次</p>
						<p><span class="ztim">2546</span>人次</p>
					</div>
				</div>
				<div class="wkitem" style="width:calc((100% - 1060px)/2);">
					<div class="ztheader">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>年度申报微课数量</span>
					</div>
					<div class="ztboxs" style="height:260px;" id="wksl" ref="wksl">
					</div>
				</div>
				<div class="wkitem" style="width:calc((100% - 1060px)/2);">
					<div class="ztheader">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>微课类型分布</span>
					</div>
					<div class="ztboxs" style="height:260px;" id="bq">

					</div>
				</div>
				<div class="wkitem" style="width:800px;">
					<div class="ztheader ztheaderss">
						<img src="@/assets/images/bigDatanew/leftline.png" alt="" />
						<span>认定微课</span>
						<div class="ztpos">
							<div class="ztitems" :class="wknum == '0' ? 'ztitemsactive' : ''" @click="getwknum('0')">
								2021
								<span class="ztcolor">(49个)</span>
							</div>
							<div class="ztitems" :class="wknum == '1' ? 'ztitemsactive' : ''" @click="getwknum('1')">
								2022
								<span class="ztcolor">(12个)</span>
							</div>
							<div class="ztitems" :class="wknum == '2' ? 'ztitemsactive' : ''" @click="getwknum('2')">
								2023
								<span class="ztcolor">(50个)</span>
							</div>
						</div>
					</div>
					<div class="ztboxs" style="height:260px;">
						<table class="tables">
							<thead>
								<tr>
									<th>序号</th>
									<th>微课名称</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>1</td>
									<td>山西革命印记</td>
								</tr>
								<tr>
									<td>3</td>
									<td>百万雄师出太行 千名号兵出陵川</td>
								</tr>
								<tr>
									<td>5</td>
									<td>立鸿鹄志，做奋斗者</td>
								</tr>
								<tr>
									<td>7</td>
									<td>社会主义核心价值观的显著特征</td>
								</tr>
							</tbody>
						</table>
						<table class="tables">
							<thead>
								<tr>
									<th>序号</th>
									<th>微课名称</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>2</td>
									<td>弘扬节气文化 展现中国气质</td>
								</tr>
								<tr>
									<td>4</td>
									<td>会计诚可贵 道德价更高</td>
								</tr>
								<tr>
									<td>6</td>
									<td>"国系青年"的百炼成钢</td>
								</tr>
								<tr>
									<td>8</td>
									<td>科技创新引领绿色环保道路</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

			</div>
		</div>
</template>

<script>
import * as echarts from 'echarts';
import HighCharts from "highcharts";
export default {
	data() {
		return {
			szlist: [{ name: '晋沃思政教育工作室' }, { name: '思政教育工作室1' }, { name: '思政教育工作室2' }, { name: '思政教育工作室3' }, { name: '思政教育工作室4' }],
			num: 0,
			num1: 0,
			pplist: [{ name: '晋成语 润人生特色文化育人品牌' }, { name: '“1+6+4”劳育实践特色文化' }, { name: '行走的思政课' }, { name: '“五心”守“初心”特色文化育人品牌' }, { name: '育心养德“1沃33651”' }],
			num2: 0,
			sjlist: [{ name: '荣誉', num: '1项' }, { name: '培育品牌', num: '2个' }],
			year: '思政工作室',
			years: '全部经费',
			brandConnotationList: [
				'爱国主义',
				'理想主义',
				'责任担当',
				'大国工匠',
				'道德修养',
			],
			brandClassifyList: [
				'传统文化',
				'晋商文化',
				'红色文化',
				'军工文化',
			],
			expenditureList: [
				{
					money: 150
				},
				{
					money: 120
				},
			],
			sz: [2021, 2022, 2023, 2024, 2025],
			sl: 0,
			wknum: 0,
		}
	},
	mounted() {
		// this.totalManey();
		// this.achievementsAct();
		// this.maneyUse();
		this.addStudio();
		this.addBradn();
        this.addCourse();
		this.getWksl();
		let VALUE1 = ['2021', '2022', '2023'];
		let VALUE2 = [3, 4, 4];
		let VALUE3 = [2, 2, 3];
		let VALUE4 = [5, 3, 4];
		let VALUE5 = ["国家级", '省级', "市级"];
		// this.zzt2d("2dzzts", VALUE1, VALUE2, VALUE3, VALUE4, VALUE5);
		let VALUE6 = [50, 72, 106];
		let VALUE7 = [115, 88, 102];
		let VALUE8 = [45, 61, 56];
		let VALUE10 = [58, 75, 55];
		let VALUE11 = [62, 43, 30];
		let VALUE9 = ["实践育人", '文化育人', "组织育人", "服务育人"];
		this.zzt2ds("ppqk", VALUE1, VALUE6, VALUE7, VALUE8, VALUE10, VALUE11, VALUE9);
		this.brandTagAct('bq', ['37%', '58%'], 10, ['0', '30%'], 14);
		this.getzx();
		this.getjsqk('jsqk');
		this.getjysq('jyzq');
		this.getszzyjsqk('szzyjsqk');
	},
	methods: {
		  addBradn() {
      var data_val = [341, 271, 273,120],
        xAxis_val = ["2021", "2022", "2023","2024"];
      var data_val1 = [0, 0, 0, 0, 0, 0, 0];
      var option = {
        grid: {
          left: 10,
          top: "10%",
          bottom: 20,
          right: 10,
          containLabel: true,
        },

        xAxis: {
          data: xAxis_val,
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#244a7f",
            },
          },
        },

        series: [
          {
            type: "line",
            name: "linedemo",
            data: data_val,
            symbol: "circle",
            symbolSize: 8,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(236, 238, 8, 0.8)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(236, 238, 8, 0)",
                    },
                  ],
                  false
                ),
              },
              shadowColor: "rgba(0, 0, 0, 0.1)",
              shadowBlur: 10,
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "rgba(236, 238, 8,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(236, 238, 8,1)",
                  },
                ]),
                label: {
                  show: true,
                  textStyle: {
                    color: "#82acd0", // 标签文字颜色
                    textBorderColor: "transparent", // 描边颜色设为透明
                    textBorderWidth: 0, // 描边宽度设为0
                  },
                },
              },
              emphasis: {
                color: "rgb(255, 255, 255)",
                borderColor: "rgba(236, 238, 8,0.2)",
                extraCssText: "box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);",
                borderWidth: 10,
              },
            },
          },
        ],
      };
      var myChart = echarts.init(this.$refs.brand);
      myChart.clear();
      myChart.setOption(option);
    },
    addCourse() {
      var m2R2Data = [
        {
          value: 1772,
          legendname: "2021",
          name: "1",
          itemStyle: { color: "#1191ff" },
        },
        {
          value: 2908,
          legendname: "2022",
          name: "2",
          itemStyle: { color: "#18e8e8" },
        },
        {
          value: 3104,
          legendname: "2023",
          name: "3",
          itemStyle: { color: "#ffae21" },
        },
        {
          value: 1650,
          legendname: "2024",
          name: "4",
          itemStyle: { color: "#74BA4C" },
        },
      ];

      let option = {
        title: [
          {
            text: "合计",
            subtext: 9434+ "个",
            textStyle: {
              fontSize: 18,
              color: "#fff",
            },
            subtextStyle: {
              fontSize: 18,
              color: "#fff",
            },
            textAlign: "center",
            x: "34.5%",
            y: "38%",
          },
        ],

        legend: {
          type: "scroll",
          orient: "vertical",
          align: "left",
          top: "middle",
          left: "60%",
          formatter: (name) => {
            for (let i of m2R2Data) {
              if (i.name == name) {
                // ${i.itemStyle.color}
                return `${i.legendname}年   ${i.value}`;
              }
            }
          },
          textStyle: {
            color: "#ftt",
          },
          height: 250,
        },
        series: [
          {
            name: "标题",
            type: "pie",
            center: ["35%", "50%"],
            radius: ["55%", "65%"],
            clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                length: 5,
                length2: 3,
                smooth: true,
              },
            },
            data: m2R2Data,
          },
        ],
      };
      var myChart = echarts.init(this.$refs.course);
      myChart.setOption(option);
    },
		addStudio() {
      HighCharts.chart("studio", {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 60,
            beta: 0,
          },
          backgroundColor: null,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#fff",
            fontSize: "14",
          },
          labelFormatter: function (i) {
            return this.name + "年";
          },
          itemHoverStyle: {
            color: "#FFFFFF", // 悬停状态下的颜色
          },
          symbolHeight: 10, // 调整图例符号高度
          symbolWidth: 10, // 调整图例符号宽度
          symbolRadius: 0, // 调整图例符号圆角
          itemMarginTop: 10,
          align: "center", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
          verticalAlign: "bottom", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
        },
        plotOptions: {
          pie: {
            size: 200,
            showInLegend: true,
            allowPointSelect: true, //每个扇块能否选中
            depth: 30, //饼图的厚度
            borderWidth: 2,
            borderColor: "#FFFFFF", // 设置边框颜色为白色
            dataLabels: {
              distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: true, //是否显示饼图的线形tip
              formatter: function (color) {
                return (
                  '<b style="color:' +
                  this.point.color +
                  ';font-size:14px;">' +
                  this.point.y
                  //  +
                  // "%</b></br>" +
                  // this.point.name +
                  // "年"
                );
              },
              style: {
                color: "#fff",
                textOutline: "none",
                fontSize: 14,
              },
            },
          },
        },
        series: [
          {
            size: 150,
            name: "建设数量",
            data: [
              // ["2024", 0],
              ["2023", 27],
              ["2022", 38],
              ["2021", 37],
            ],
            colors: ["#FFC808", "#FE8D37", "#517FD9"],
            // colors: ["#80CB4B", "#FFC808", "#FE8D37", "#517FD9"],
          },
        ],
      });
    },
		getwknum(num) {
			this.wknum = num;
		},
		getcg(num) {
			this.sl = num;
		},
		handleChange() {

		},
		handleChanges() {

		},
		getszzyjsqk(id) {
			var myChart = echarts.init(document.getElementById(id));
			let color = ["#FF8D37", "#FFC809", "#80CB4C", "#38CEC2", '#F75668', '#23458B', '#9C7C07', '#527FDA'];
			let data1 = [
				{
					value: 120,
					name: "教学视频",
				},
				{
					value: 100,
					name: "短视频",
				},
				{
					value: 180,
					name: "其他资源",
				},
				{
					value: 140,
					name: "场馆数字资源",
				},
				{
					value: 140,
					name: "课件",
				},
				{
					value: 240,
					name: "微课",
				},
				{
					value: 140,
					name: "动画",
				},
				{
					value: 140,
					name: "其他资源",
				}
			];

			// 移除会破坏数据结构的代码
			// color.splice(data1.length, data1.length - 1);
			// data1.map((item, index) => {
			//     data1.push({ value: 0, name: "" });
			//     color.push("transparent");
			// });

			let option = {
				backgroundColor: "",
				title: {
					text: "",
				},
				tooltip: {
					show: true,
					formatter: '{b}: {c}'
				},
				legend: {
					icon: "circle",
					top: "1%",
					textStyle: {
						color: "#fff",
					},
					show: false,
				},
				series: [
					{
						name: "玫瑰图",
						type: "pie",
						startAngle: 50, // 从顶部开始
						radius: [20, 105],
						center: ["50%", "50%"],
						roseType: "area",
						avoidLabelOverlap: true, // 改为true避免标签重叠
						itemStyle: {
							color: function (params) {
								return color[params.dataIndex];
							},
						},
						label: {
							show: true,
							fontSize: 12,
							formatter: function (params) {
								// console.log(params,"4444");
								return `{name|${params.name}}\n{value|${params.percent}%}`;
							},
							rich: {
								name: {
									fontSize: 12,
									color: "#fff",
									fontWeight: 'bold',
									padding: [2, 0]
								},
								value: {
									fontSize: 14,
									color: function (params) {
										return color[params.dataIndex];
									},
									fontWeight: 'bold'
								},
								hr: {
									width: "100%",
									borderWidth: 0.5,
									borderColor: "#fff",
									height: 0,
								}
							},
							position: 'outer', // 标签放在外部
							alignTo: 'none',
							margin: 5,     // 移除 alignTo
							margin: 8,           // 减小边距
							distanceToLabelLine: 5, // 标签与引导线的距离
							bleedMargin: 5       // 防止标签被截断
						},
						labelLine: {
							show: true,
							length: 5,
							length2: 5,
							lineStyle: {
								width: 1,
								color: 'rgba(255,255,255,0.5)'
							}
						},
						emphasis: { // 高亮样式
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						data: data1.map((item, index) => {
							return {
								value: item.value,
								name: item.name,
								itemStyle: {
									color: color[index]
								}
							};
						})
					}
				]
			};

			myChart.clear();
			myChart.setOption(option);
		},
		getjysq(id) {
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				grid: {
					top: '25px',
					bottom: '30px',
					left: '40px',
				},
				legend: {
					position: 'right',
					right: 10, // 距离右侧10px
					icon: 'circle', // 设置为圆形
					textStyle: {
						color: '#fff', // 文字颜色为白色
						fontSize: 12,  // 文字大小
						fontWeight: 'normal' // 文字粗细
					},
					itemStyle: {
						color: '#D4A878', // 圆形边框颜色
					},
				},
				xAxis: {
					type: 'value',
					boundaryGap: [0, 0.01],
					axisLabel: {
						color: '#68A8CC',  // 修改 X 轴文字颜色为白色
						fontSize: 14,    // 设置字体大小
					},
					splitLine: {
						show: false,  // 显示网格线
						lineStyle: {
							color: 'red',  // 设置网格线颜色
							type: 'dashed'  // 设置网格线样式为虚线
						}
					}
				},
				yAxis: {
					type: 'category',
					data: ['2021', '2022', '2023', '2024'],
					axisLabel: {
						color: '#68A8CC',  // 修改 Y 轴文字颜色为白色
						fontSize: 14,    // 设置字体大小
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,  // 显示网格线
						lineStyle: {
							color: '#68A8CC',  // 设置网格线颜色
							type: 'solid'  // 设置网格线样式为虚线
						}
					}
				},
				series: [
					{
						name: '教研周期',
						type: 'bar',
						data: [1000, 1320, 1999, 800],
						barWidth: 20,
						itemStyle: {
							// 为每个柱子定义不同的渐变色
							normal: {
								color: function (params) {
									const colorList = [
										new echarts.graphic.LinearGradient(0, 0, 1, 0, [
											{ offset: 0, color: '#ce6a01' }, // 红色
											{ offset: 1, color: '#fffea7' }  // 橙红色
										]),
										// new echarts.graphic.LinearGradient(0, 0, 1, 0, [
										// 	{ offset: 0, color: '#2724a5' }, // 绿
										// 	{ offset: 1, color: '#8078e3' }  // 深绿
										// ]),
										// new echarts.graphic.LinearGradient(0, 0, 1, 0, [
										// 	{ offset: 0, color: '#038001' }, // 蓝色
										// 	{ offset: 1, color: '#a7fd76' }  // 天蓝色
										// ]),
										// new echarts.graphic.LinearGradient(0, 0, 1, 0, [
										// 	{ offset: 0, color: '#9370db' }, // 紫色
										// 	{ offset: 1, color: '#8a2be2' }  // 蓝紫色
										// ]),
										// new echarts.graphic.LinearGradient(0, 0, 1, 0, [
										// 	{ offset: 0, color: '#ffd700' }, // 金色
										// 	{ offset: 1, color: '#ff6347' }  // 番茄红色
										// ])
									];
									return colorList[0];
								},
								borderRadius: [0, 100, 100, 0],
							},

						},
						label: {
							show: true,
							position: 'right',
							color: '#fff',
							fontSize: 14,
							fontWeight: 'bold'
						}
					},
				]
			};
			myChart.setOption(option);
		},
		getjsqk(id) {
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				grid: {
					top: '15px',
					bottom: '50px',
					left: '60px',
				},
				xAxis: {
					type: 'value',
					boundaryGap: [0, 0.01],
					axisLabel: {
						color: '#68A8CC',  // 修改 X 轴文字颜色为白色
						fontSize: 14,    // 设置字体大小
					},
					splitLine: {
						show: false,  // 显示网格线
						lineStyle: {
							color: 'red',  // 设置网格线颜色
							type: 'dashed'  // 设置网格线样式为虚线
						}
					}
				},
				yAxis: {
					type: 'category',
					data: ['德育在线教育平台', '智慧德育管理系统', '网络德育云平台'],
					axisLabel: {
						color: '#68A8CC',  // 修改 Y 轴文字颜色为白色
						fontSize: 14,    // 设置字体大小
						formatter: function (value) {
							// 每4个字符换行
							return value.replace(/(.{3})/g, '$1\n');
						}
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,  // 显示网格线
						lineStyle: {
							color: '#68A8CC',  // 设置网格线颜色
							type: 'solid'  // 设置网格线样式为虚线
						}
					}
				},
				series: [
					{
						name: '2011',
						type: 'bar',
						data: [18203, 23489, 29034],
						barWidth: 24,
						itemStyle: {
							// 为每个柱子定义不同的渐变色
							normal: {
								color: function (params) {
									const colorList = [
										new echarts.graphic.LinearGradient(0, 0, 1, 0, [
											{ offset: 0, color: '#ce6a01' }, // 红色
											{ offset: 1, color: '#fffea7' }  // 橙红色
										]),
										new echarts.graphic.LinearGradient(0, 0, 1, 0, [
											{ offset: 0, color: '#2724a5' }, // 绿
											{ offset: 1, color: '#8078e3' }  // 深绿
										]),
										new echarts.graphic.LinearGradient(0, 0, 1, 0, [
											{ offset: 0, color: '#038001' }, // 蓝色
											{ offset: 1, color: '#a7fd76' }  // 天蓝色
										]),
										new echarts.graphic.LinearGradient(0, 0, 1, 0, [
											{ offset: 0, color: '#9370db' }, // 紫色
											{ offset: 1, color: '#8a2be2' }  // 蓝紫色
										]),
										new echarts.graphic.LinearGradient(0, 0, 1, 0, [
											{ offset: 0, color: '#ffd700' }, // 金色
											{ offset: 1, color: '#ff6347' }  // 番茄红色
										])
									];
									return colorList[params.dataIndex];
								},
								borderRadius: [0, 100, 100, 0],

							},


						},
						label: {
							show: true,
							position: 'right',
							color: '#fff',
							fontSize: 14,
							fontWeight: 'bold'
						}
					},
				]
			};
			myChart.setOption(option);
		},
		brandTagAct(id, arr1, value, value1, value2) {
			var myChart = echarts.init(document.getElementById(id));
			let list = [
				{
					name: "实践类课程",
					value: 17.1,
					label: {
						textStyle: {
							color: "#FFC808",
							fontSize: 16,
							fontWeight: 400,
							borderColor: "#001F61",
						},
					},
				},
				{
					name: "公共基础课",
					value: 43.3,
					label: {
						textStyle: {
							color: "#80CB4B",
							fontSize: 16,
							fontWeight: 400,
							borderColor: "#001F61",
						},
					},
				},
				{
					name: "专业基础课",
					value: 39.7,
					label: {
						textStyle: {
							color: "#0084FF",
							fontSize: 16,
							fontWeight: 400,
							borderColor: "#001F61",
						},
					},
				},
			];

			let list1 = [
				{
					name: "实践类课程",
					value: 10,
					itemStyle: { color: 'rgba(16,108,255,0.3)' }
				},
				{
					name: "公共基础课",
					value: 12,
					itemStyle: { color: 'rgba(0,184,255,0.3)' }
				},
				{
					name: "专业基础课",
					value: 33,
					itemStyle: { color: 'rgba(255,98,98,0.3)' }
				},
			];
			let angle = 0;
			let option = {
				color: [
					"#FFC808",
					"#80CB4B",
					"#0084FF",
					"#ffb81a",
					"#6fef33",
					"#106bff",
					"#8d4bbb",
					"#6635EF",
					"#FFAFDA",
				],
				tooltip: {
					show: false,
				},
				legend: {
					show: false,
				},
				series: [
					{
						itemStyle: {
							normal: {
								borderColor: "#001553",
								borderWidth: 2,
							},
						},
						name: "访问来源",
						type: "pie",
						center: ['50%', '50%'],
						radius: arr1,
						label: {
							normal: {
								formatter: "{b|{d}%}\n{hr|}\n{d|{b}}",
								rich: {
									b: {
										fontSize: value2,
										align: "left",
										padding: 4,
									},
									hr: {
										borderColor: "#12EABE",
										width: "100%",
										borderWidth: 2,
										height: 0,
									},
									d: {
										fontSize: value2,
										color: "#fff",
										align: "left",
										padding: 4,
									},
									c: {
										fontSize: value2,
										color: "#fff",
										align: "center",
										padding: 4,
									},
								},
							},
						},
						labelLine: {
							normal: {
								show: true,
								length: value,
								length2: value,
								lineStyle: {
									type: "dashed",
									width: 2,
								},
							},
						},
						data: list,
					},
					{
						name: "访问来源",
						type: "pie",
						clockwise: true,
						hoverAnimation: false,
						coordinateSystem: "none",
						radius: value1,
						center: ['50%', '50%'],
						data: [100],
						itemStyle: {
							normal: {
								color: "#043173",
							},
						},
						label: {
							show: false,
						},
						labelLine: {
							normal: {
								show: false,
								length: value,
								length2: value,
								lineStyle: {
									type: "dashed",
									width: 2,
								},
							},
						},
					},
				],
			};
			//	  	  myChart.clear();
			myChart.setOption(option);
		},
		getzx() {
			var myChart = echarts.init(this.$refs.zxt);
			let option = {
				title: {
					text: '',
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: ['教育基地1', '教育基地2', '教育基地3'],
					textStyle: {
						color: '#ffffff' //字体颜色
					},
					x: 'right',        // 右侧
					y: 'top',
				},
				grid: {
					left: '2px',
					right: '2px',
					bottom: '2px',
					top: '80px',
					containLabel: true
				},
				toolbox: {
					show: false,
				},
				xAxis: [
					{
						type: "category",
						data: ["2021", "2022", "2023", "2024"],
						axisPointer: {
							type: "shadow",
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#3c71c1",
							}
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "(人)",
						min: 0,
						max: 80000,
						interval: 10000,
						axisLabel: {
							formatter: "{value}",
						},
						nameTextStyle: {
							color: "#68A8CC",
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
							show: true, // 是否显示分隔线
							lineStyle: {
								color: '#68A8CC', // 分隔线颜色
							}
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
						},
					},
				],
				series: [
					{
						name: '教育基地1',
						type: 'line',
						data: [49231, 58456, 61250, 75420],
						color: '#2CAFFE'
					},
					{
						name: '教育基地2',
						type: 'line',
						data: [29540, 25103, 32489, 30441],
						color: '#FEAC2C'
					},
					{
						name: '教育基地3',
						type: 'line',
						data: [0, 0, 8541, 15421],
						color: '#2CFE58'
					},
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		getWksl() {
			var myChart = echarts.init(this.$refs.wksl);
			let option = {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "cross",
						crossStyle: {
							color: "#999",
						},
					},
				},
				toolbox: {
					show: false,
				},
				legend: {
					show: false,
				},
				grid: {
					containLabel: true,
					left: 5,
					right: 2,
					bottom: 10,
					top: 30,
					borderColor: '#68A8CC',
				},
				xAxis: [
					{
						type: "category",
						data: ["2021", "2022", "2023"],
						axisPointer: {
							type: "shadow",
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
							// formatter: function (value) {
							// 	let rowMAx = 4;
							// 	let overValue = "";
							// 	for (let i = 0; i < value.length; i++) {
							// 	if (i % rowMAx == 0 && i != 0) {
							// 		overValue += "\n";
							// 		overValue += value[i];
							// 	} else {
							// 		overValue += value[i];
							// 	}
							// 	}
							// 	return overValue;
							// },
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#3c71c1",
							}
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "(个)",
						min: 0,
						max: 250,
						interval: 50,
						axisLabel: {
							formatter: "{value}",
						},
						nameTextStyle: {
							color: "#68A8CC",
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
							show: true, // 是否显示分隔线
							lineStyle: {
								color: '#68A8CC', // 分隔线颜色
							}
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
						},
					},
				],
				series: [
					{
						name: "年度申报微课数量",
						type: "bar",
						barWidth: "20",
						tooltip: {
							valueFormatter: function (value) {
								return value + "";
							},
						},
						label: {
							show: true,            // 显示数据标签
							position: 'top',       // 标签位置在柱子顶部
							color: '#fff',         // 标签文字颜色
							fontSize: 14,          // 标签文字大小
							formatter: '{c}'       // 标签内容格式化，{c} 表示数据值
						},
						itemStyle: {
							normal: {
								borderColor: "#27D027", // 描边颜色
								borderWidth: 2, // 描边宽度
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0.3,
											color: "#26D972", // 0% 处的颜色
										},
										{
											offset: 1,
											color: "#0B3B1F", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						data: [20, 28, 42],
					},
				],
			};
			myChart.clear();
			myChart.setOption(option);

		},
		tabitem(index) {
			this.num2 = index;
		},
		zzt2d(id, value, value1, value2, value3, VALUE10) {
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				grid: {
					containLabel: true,
					left: 5,
					right: 10,
					bottom: 10,
					top: 28,
				},
				legend: {
					data: VALUE10,
					textStyle: {
						color: '#ffffff' //字体颜色
					},
					x: 'right',        // 右侧
					y: 'top',
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				xAxis: {
					type: 'category',
					data: value,
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: function (value) {
							let rowMAx = 4
							let overValue = ''
							for (let i = 0; i < value.length; i++) {
								if ((i % rowMAx == 0) && (i != 0)) {
									overValue += '\n'
									overValue += value[i]
								} else {
									overValue += value[i]
								}
							}
							return overValue
						},
					},
					axisTick: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#3c71c1",
						}
					},
				},
				yAxis: {
					type: 'value',
					name: '',
					nameTextStyle: {
						color: '#68A8CC',
					},
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},

					},
					axisLine: {
						show: false,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: true, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					}
				},
				series: [{
					name: VALUE10[0],
					data: value1,
					type: 'bar',
					barWidth: "15",
					barGap: '40%',
					itemStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#55FDFE' // 0% 处的颜色
							}, {
								offset: 1,
								color: '#022486' // 100% 处的颜色
							}], false),
						}
					},
					showBackground: false,
					backgroundStyle: {
						color: '#04195e'
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff',
					}

				},
				{
					name: VALUE10[1],
					data: value2,
					type: 'bar',
					barWidth: "15",
					barGap: '40%',
					showBackground: false,
					backgroundStyle: {
						color: '#04195e'
					},
					itemStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#A8FD77' // 0% 处的颜色
							}, {
								offset: 1,
								color: '#064A4D' // 100% 处的颜色
							}], false),
						}
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff',
					}

				},
				{
					name: VALUE10[2],
					data: value3,
					type: 'bar',
					barGap: '40%',
					barWidth: "15",
					showBackground: false,
					backgroundStyle: {
						color: '#04195e'
					},
					itemStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#FFFEEF' // 0% 处的颜色
							}, {
								offset: 1,
								color: '#C28143' // 100% 处的颜色
							}], false),
						}
					},
					label: {
						show: true,
						position: 'top',
						color: '#fff',
					}

				}
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		zzt2ds(id, value, value1, value2, value3, value4, value5, VALUE10) {
			var myChart = echarts.init(document.getElementById(id));
			let option = {
				grid: {
					containLabel: true,
					left: 5,
					right: 15,
					bottom: 15,
					top: 48,
				},
				legend: {
					data: VALUE10,
					textStyle: {
						color: '#ffffff' //字体颜色
					},
					x: 'right',        // 右侧
					y: 'top',
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				xAxis: {
					type: 'category',
					data: value,
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},
						formatter: function (value) {
							let rowMAx = 4
							let overValue = ''
							for (let i = 0; i < value.length; i++) {
								if ((i % rowMAx == 0) && (i != 0)) {
									overValue += '\n'
									overValue += value[i]
								} else {
									overValue += value[i]
								}
							}
							return overValue
						},
					},
					axisTick: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#3c71c1",
						}
					},
				},
				yAxis: {
					type: 'value',
					name: '(个)',
					nameTextStyle: {
						color: '#68A8CC',
					},
					axisLabel: {
						textStyle: {
							color: "#68A8CC"
						},

					},
					axisLine: {
						show: false,
						lineStyle: {
							color: "#68A8CC",
						}
					},
					splitLine: { // y 轴分隔线配置
						show: true, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					}
				},
				series: [
					{
						name: VALUE10[0],
						data: value1,
						type: 'bar',
						barWidth: "15",
						barGap: '40%',
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#54FAFD' // 0% 处的颜色
								}, {
									offset: 1,
									color: '#02267A' // 100% 处的颜色
								}], false),
							}
						},
						showBackground: false,
						backgroundStyle: {
							color: '#04195e'
						},
						label: {
							show: true,
							position: 'top',
							color: '#fff',
						},
					},
					{
						name: VALUE10[1],
						data: value2,
						type: 'bar',
						barWidth: "15",
						barGap: '40%',
						showBackground: false,
						backgroundStyle: {
							color: '#04195e'
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#A9FE78' // 0% 处的颜色
								}, {
									offset: 1,
									color: '#075A3B' // 100% 处的颜色
								}], false),
							}
						},
						label: {
							show: true,
							position: 'top',
							color: '#fff',
						}

					},
					{
						name: VALUE10[2],
						data: value3,
						type: 'bar',
						barGap: '40%',
						barWidth: "15",
						showBackground: false,
						backgroundStyle: {
							color: '#04195e'
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#81FEFE' // 0% 处的颜色
								}, {
									offset: 1,
									color: '#095794' // 100% 处的颜色
								}], false),
							}
						},
						label: {
							show: true,
							position: 'top',
							color: '#fff',
						}
					},
					{
						name: VALUE10[3],
						data: value4,
						type: 'bar',
						barGap: '40%',
						barWidth: "15",
						showBackground: false,
						backgroundStyle: {
							color: '#04195e'
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#544FC5' // 0% 处的颜色
								}, {
									offset: 1,
									color: '#05207D' // 100% 处的颜色
								}], false),
							}
						},
						label: {
							show: true,
							position: 'top',
							color: '#fff',
						}
					},
					{
						name: VALUE10[4],
						data: value5,
						type: 'bar',
						barGap: '40%',
						barWidth: "15",
						showBackground: false,
						backgroundStyle: {
							color: '#04195e'
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#FDFAA3' // 0% 处的颜色
								}, {
									offset: 1,
									color: '#CC872F' // 100% 处的颜色
								}], false),
							}
						},
						label: {
							show: true,
							position: 'top',
							color: '#fff',
						}
					},
				]
			};
			myChart.clear();
			myChart.setOption(option);
		},
		tabsz(num) {
			this.num = num;
		},
		tabpp(num) {
			this.num1 = num;
		},
		achievementsAct() {
			var myChart = echarts.init(this.$refs.achievements);
			let color = ["#FFD900", "#517FD9", "#FF7E00", "#00A1E4"];
			let data1 = [
				{
					value: 120,
					name: "省补贴",
					value1: "95",
					label: {
						textStyle: {
							color: "#FFD900",
							fontSize: 16,
							fontWeight: 600,
							borderColor: "#FFD900",
						},
					},
				},
				{
					value: 100,
					name: "地方",
					value1: "90",
					label: {
						textStyle: {
							color: "#517FD9",
							fontSize: 16,
							fontWeight: 600,
							borderColor: "#517FD9",
						},
					},
				},
				{
					value: 80,
					name: "学校自筹",
					value1: "80",
					label: {
						textStyle: {
							color: "#FF7E00",
							fontSize: 16,
							fontWeight: 600,
							borderColor: "#FF7E00",
						},
					},
				},
				{
					value: 40,
					name: "其他来源",
					value1: "70",
					label: {
						textStyle: {
							color: "#00A1E4",
							fontSize: 16,
							fontWeight: 600,
							borderColor: "#00A1E4",
						},
					},
				},
			];
			// data1.sort(function (a, b) {
			// 	return a.value - b.value;
			// });
			color.splice(data1.length, data1.length - 1);
			data1.map((item, index) => {
				data1.push({ value: 0, name: "" });
				color.push("transparent");
			});
			let option = {
				backgroundColor: "",
				title: {
					text: "",
				},
				tooltip: {
					show: false,
				},
				legend: {
					icon: "circle",
					top: "1%",
					textStyle: {
						color: "#fff",
					},
				},
				series: [
					{
						name: "玫瑰图",
						type: "pie",
						startAngle: 180,
						radius: [50, 100],
						center: ["50%", "90%"],
						roseType: "area",
						avoidLabelOverlap: false,
						itemStyle: {
							normal: {
								color: function (params) {
									return color[params.dataIndex];
								},
							},
						},
						label: {
							show: true,
							fontSize: 14,
							formatter: function (params) {
								//				                	  console.log(params);
								// +
								// 	params.value +
								return params.value
									? "{a|" +
									'***' + "}%\n " +
									"{hr|}\n" + // 插入水平线
									"{b|" +
									params.name +
									"}" // 这里可以添加更多的文本或变量
									: "";
							},
							textStyle: {
								color: "#ftt",
							},
							rich: {
								hr: {
									width: "100%",
									borderWidth: 0.5,
									borderColor: "#fff",
									height: 0,
								},
								b: {
									color: "#fff",
								},
								// 可以添加更多的样式定义
							},
						},
						labelLine: {
							normal: {
								length: 10,
								length2: 10,
								show: true,
								lineStyle: {
									width: 1,
								},
							},
						},
						data: data1,
					},
				],
			};
			myChart.clear();
			myChart.setOption(option);
		},

		maneyUse() {
			var myChart = echarts.init(this.$refs.maneyUse);
			let option = {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "cross",
						crossStyle: {
							color: "#999",
						},
					},
				},
				toolbox: {
					show: false,
				},
				legend: {
					show: false,
				},
				grid: {
					containLabel: true,
					left: 5,
					right: 2,
					bottom: 10,
					top: 30,
					borderColor: '#68A8CC',
				},
				xAxis: [
					{
						type: "category",
						data: ["2021", "2022", "2023"],
						axisPointer: {
							type: "shadow",
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
							// formatter: function (value) {
							// 	let rowMAx = 4;
							// 	let overValue = "";
							// 	for (let i = 0; i < value.length; i++) {
							// 	if (i % rowMAx == 0 && i != 0) {
							// 		overValue += "\n";
							// 		overValue += value[i];
							// 	} else {
							// 		overValue += value[i];
							// 	}
							// 	}
							// 	return overValue;
							// },
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#68A8CC",
							},
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "(万元)",
						min: 0,
						max: 250,
						interval: 50,
						axisLabel: {
							formatter: "{value}",
						},
						nameTextStyle: {
							color: "#68A8CC",
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
							show: true, // 是否显示分隔线
							lineStyle: {
								color: '#68A8CC', // 分隔线颜色
							}
						},
					},
				],
				series: [
					{
						name: "项目资金使用",
						type: "bar",
						barWidth: "20",
						tooltip: {
							valueFormatter: function (value) {
								return value + "";
							},
						},
						label: {
							show: true,            // 显示数据标签
							position: 'top',       // 标签位置在柱子顶部
							color: '#fff',         // 标签文字颜色
							fontSize: 14,          // 标签文字大小
							formatter: '{c}'       // 标签内容格式化，{c} 表示数据值
						},
						itemStyle: {
							normal: {
								borderColor: "#0096FF", // 描边颜色
								borderWidth: 2, // 描边宽度
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0.3,
											color: "#00A4F6", // 0% 处的颜色
										},
										{
											offset: 1,
											color: "#002C86", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						data: [75, 83, 100],
					},
				],
			};
			myChart.clear();
			myChart.setOption(option);
		},
		totalManey() {
			var myChart = echarts.init(this.$refs.totalManey);
			let option = {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "cross",
						crossStyle: {
							color: "#999",
						},
					},
				},
				toolbox: {
					show: false,
				},
				legend: {
					data: ["预算资金", "实际使用资金",],
					textStyle: {
						color: "#fff",
					},
					x: 'right',        // 右侧
					y: 'top',
				},
				grid: {
					containLabel: true,
					left: 5,
					right: 2,
					bottom: 10,
					top: 30,
					borderColor: '#68A8CC',
				},
				xAxis: [
					{
						type: "category",
						data: ["思政工作室", "特色文化育人品牌", "思政微课"],
						axisPointer: {
							type: "shadow",
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
							formatter: function (value) {
								let rowMAx = 6;
								let overValue = "";
								for (let i = 0; i < value.length; i++) {
									if (i % rowMAx == 0 && i != 0) {
										overValue += "\n";
										overValue += value[i];
									} else {
										overValue += value[i];
									}
								}
								return overValue;
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#68A8CC",
							},
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "(万元)",
						min: 0,
						max: 250,
						interval: 50,
						axisLabel: {
							formatter: "{value}",
						},
						nameTextStyle: {
							color: "#68A8CC",
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC",
							},
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
							show: true, // 是否显示分隔线
							lineStyle: {
								color: '#68A8CC', // 分隔线颜色
							}
						},
					},
				],
				series: [
					{
						name: "预算资金",
						type: "bar",
						barWidth: "20",
						tooltip: {
							valueFormatter: function (value) {
								return value + "";
							},
						},
						label: {
							show: true,            // 显示数据标签
							position: 'top',       // 标签位置在柱子顶部
							color: '#fff',         // 标签文字颜色
							fontSize: 14,          // 标签文字大小
							formatter: '{c}'       // 标签内容格式化，{c} 表示数据值
						},
						itemStyle: {
							normal: {
								borderColor: "#0096FF", // 描边颜色
								borderWidth: 2, // 描边宽度
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0.3,
											color: "#00A4F6", // 0% 处的颜色
										},
										{
											offset: 1,
											color: "#002C86", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						data: [50, 68, 110],
					},
					{
						barWidth: "20",
						name: "实际使用资金",
						type: "bar",
						tooltip: {
							valueFormatter: function (value) {
								return value + "";
							},
						},
						label: {
							show: true,            // 显示数据标签
							position: 'top',       // 标签位置在柱子顶部
							color: '#fff',         // 标签文字颜色
							fontSize: 14,          // 标签文字大小
							formatter: '{c}'       // 标签内容格式化，{c} 表示数据值
						},
						itemStyle: {
							normal: {
								borderColor: "#FF9C00", // 描边颜色
								borderWidth: 2, // 描边宽度
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0.3,
											color: "#F9AF56", // 0% 处的颜色
										},
										{
											offset: 1,
											color: "#442E18", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						data: [74, 72, 97],
					},
				],
			};
			myChart.clear();
			myChart.setOption(option);
		}
	}
}
</script>

<style lang="scss" scoped>
p {
	margin: 0px;
	padding: 0px;
}

.flex {
	display: flex;
}

.spa-bet {
	justify-content: space-between;
}

.spa-aro {
	justify-content: space-around;
}

.align-center {
	align-items: center;
}

.tables {
	width: 50%;
	height: 100%;
	float: left;

	thead {
		tr {
			height: 50px;
			line-height: 50px;
			background: rgba(21, 64, 144, 0.38);
			color: #8298FB;
			font-size: 16px;
			text-align: center;
		}
	}

	tbody {
		tr {
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #092260;
			color: #fff;
			text-align: center;
			font-size: 14px;
		}
	}
}

.wkbox {
	height: 310px;
	padding-bottom: 30px;
	box-sizing: content-box;

	.wkitem {
		width: calc((100% - 40px)/4);
		height: 100%;

		.wkitem-item {
			width: 100%;
			height: 76px;
			margin-bottom: 4px;
			background: url("~@/assets/images/bigData/tbg6.png") no-repeat;
			background-size: 100% 100%;
			display: flex;
			justify-content: space-between;
			line-height: 85px;
			font-size: 14px;
			color: #fff;
			padding: 0px 20px;
			box-sizing: border-box;
		}
	}
}

.xxitem {
	width: 25%;
	min-height: 110px;
	margin: 20px 0px 23px;
	float: left;

	.xximg {
		width: 86px;
		height: 80px;
		line-height: 70px;
		text-align: center;
		font-weight: bold;
		font-size: 18px;
		color: #fff;
		margin: 0px auto;
		background: url("~@/assets/images/bigData/tbg5.png") no-repeat;
		background-size: 100% 100%;
	}

	>p {
		width: 86px;
		line-height: 20px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		margin: 0px auto;
	}
}

.zt-around {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-around;
	align-items: center;

	.zt-around-text {
		background: radial-gradient(0% 0% at 0% 0%, #001861 100%);
		border: 1px solid;
		border-image: radial-gradient(circle, rgba(7, 81, 144, 1)) 1 1;
		width: 19%;
		height: 26px;
		text-align: center;
		line-height: 26px;
		color: #fff;
		font-size: 14px;
		cursor: pointer;
	}

	.zt-around-active {
		background: linear-gradient(0deg, #0055d5, #002183);
		border: 1px solid #2155b4;
	}

	.zt-around-item {
		width: 120px;
		height: 170px;

		.zt-around-one {
			width: 100%;
			height: 30px;
			// margin-bottom: 15px;
			// background: url("~@/assets/images/bigData/tbg3.png") no-repeat;
			// background-size: 100% 100%;
			text-align: center;
			line-height: 30px;
			margin-top: -10px;
			font-size: 16px;
			color: #fff;
		}

		.zt-around-two {
			width: 113px;
			height: 117px;
			margin: 20px auto 0px;
			background: url("~@/assets/images/bigDatanew/hd.png") no-repeat;
			background-size: 100% 100%;
			font-weight: bold;
			font-size: 18px;
			color: #FFD70E;
			text-align: center;
			line-height: 60px;
		}
	}
}

.tablist {
	width: 100%;
	height: 35px;
	display: flex;
	justify-content: flex-start;
	align-items: center;

	.tabitem {
		height: 35px;
		line-height: 35px;
		padding: 0px 10px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		border-bottom: 2px solid transparent;
		cursor: pointer;

		.tabnum {
			color: #02E1E9;
		}
	}

	.tabactive {
		background: linear-gradient(0deg, rgba(2, 116, 233, 0.5) 0%, rgba(2, 116, 233, 0) 100%);
		border-bottom: 2px solid #0274E9;
		font-weight: bold;
	}
}

.ztbox {
	width: 100%;
	min-width: 1732px;
	overflow-x: auto;
	height: auto;
	box-sizing: border-box;
	flex: 1;

	.ztone {
		width: 100%;
		height: 330px;

		&-item {
			width: 19%;
			height: 100%;

			&-header {
				width: 100%;
				height: 36px;
				background: url("~@/assets/images/bigDatanew/bg2.png") no-repeat;
				background-size: 100% 100%;
				margin-bottom: 10px;
				margin-top: 10px;
				// line-height: 44px;
				line-height: 20px;
				// padding: 0px 12px;
				padding: 0px 12px 0px 1px;
				box-sizing: border-box;
				position: relative;

				.ztpos {
					height: 36px;
					position: absolute;
					top: -10px;
					right: 12px;
				}

				>img {
					width: 14px;
					height: 18px;
					margin-top: -8px;
					// margin-right: 5px;
				}

				>span {
					color: #02F4F5;
					font-size: 20px;
					font-weight: bold;
				}
			}

			&-headers {
				background: url("~@/assets/images/bigDatanew/big2_1.png") no-repeat;
				background-size: 100% 100%;
			}

			&-headerss {
				background: url("~@/assets/images/bigDatanew/big2_2.png") no-repeat;
				background-size: 100% 100%;
			}

			&-box {
				width: 100%;
				height: 278px;
				background: rgba(0, 24, 97, .2);
				border: 1px solid #075190;
				border-image: linear-gradient(0deg, #075190) 10 10;
				padding: 12px;
				box-sizing: border-box;

				&-zjitem {
					height: 50px;
					margin-bottom: 16px;
					background: url("~@/assets/images/bigData/obg1.png") no-repeat;
					background-size: 100% 100%;
					font-size: 14px;
					color: #fff;
					padding: 0px 14px;
					box-sizing: border-box;

					&-per {
						font-weight: bold;
						color: #FFD70E;
					}
				}

				&-list {
					height: 42px;

					&-item {
						width: 49%;
						height: 42px;
						background: url("~@/assets/images/bigData/obg.png") no-repeat;
						background-size: 100% 100%;
						text-align: center;
						line-height: 42px;
						font-size: 14px;
						color: #fff;

						>span {
							color: #F7D014;
							font-weight: bold;
						}
					}
				}

				&-box {
					width: 100%;
					height: 236px;
				}

				&-img {
					width: 100%;
					height: 1px;
				}

				&-item {
					// margin:12px 0px;
					display: flex;
					justify-content: flex-start;

					&-img {
						width: 61px;
						height: 65px;
						margin-right: 10px;
					}

					&-sj {
						height: 65px;
						padding: 15px 0px;
						box-sizing: border-box;

						&-num {
							font-size: 14px;
							color: #FFD70E;
							height: 18px;
							line-height: 18px;
							font-weight: bold;
						}

						&-text {
							font-size: 14px;
							color: #fff;
							height: 17px;
							line-height: 17px;
						}
					}
				}
			}
		}
	}

	.ztbt {
		margin: 10px 0px;
		height: 34px;

		.ztimg {
			width: calc((100%- 230px)/2);
			height: 9px;
		}

		.zttitle {
			width: 200px;
			height: 34px;
			font-weight: bold;
			font-size: 20px;
			background: url("~@/assets/images/bigData/obg5.png") no-repeat;
			background-size: 100% 100%;
			color: #FFFFFF;
			text-align: center;
			flex: 0 0 auto;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.ztbt-two {
		width: 100%;
		height: 34px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;

		>span {
			min-width: 100px;

		}

		>img {
			width: calc(100% - 100px);
			height: 8px;
		}
	}

	.ztlist {
		width: 100%;
		overflow: hidden;
		overflow-x: auto;
		display: flex;
		overflow-x: auto;
		height: 72px;

		.ztitem {
			width: 20%;
			height: 72px;
			flex: 0 0 auto;
			// float:left;
			background: url("~@/assets/images/bigData/obg6.png") no-repeat;
			background-size: 100% 100%;
			text-align: center;
			font-size: 16px;
			color: #fff;
			cursor: pointer;
			padding: 10px 10px;
			box-sizing: border-box;
			line-height: 52px;
		}

		.ztactive {
			background: url("~@/assets/images/bigData/obg7.png") no-repeat;
			background-size: 100% 100%;
			font-weight: bold;
		}
	}

	.ztheader {
		width: 100%;
		height: 36px;
		// background: url("~@/assets/images/bigData/bg2.png") no-repeat;
		background: url("~@/assets/images/bigDatanew/bigxin.png") no-repeat;
		background-size: 100% 100%;
		margin-bottom: 10px;
		margin-top: 10px;
		line-height: 20px;
		padding: 0 12px 0 1px;
		box-sizing: border-box;
		position: relative;

		.ztpos {
			position: absolute;
			height: 36px;
			top: -10px;
			right: 0px;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.ztitems {
				background: radial-gradient(0 0 at 0 0, #001861 100%);
				border: 1px solid;
				border-image: radial-gradient(circle, #075190) 1 1;
				height: 25px;
				padding: 0px 12px;
				line-height: 25px;
				color: #fff;
				font-size: 14px;
				display: inline-block;
				margin-right: 10px;
				cursor: pointer;

				.ztcolor {
					color: #01CCFF;
					font-weight: bold;
				}
			}

			.ztitemsactive {
				background: linear-gradient(0deg, #0055D5 0%, #002183 100%);
				border: 1px solid #2155B4;
			}
		}

		>img {
			width: 14px;
			height: 18px;
			margin-top: -8px;
			// margin-right: 10px;
		}

		>span {
			color: #02F4F5;
			font-size: 20px;
			font-weight: bold;
		}
	}

	.ztheaders {
		background: url("~@/assets/images/bigDatanew/bigxin1.png") no-repeat;
		background-size: 100% 100%;
	}

	.ztheaderss {
		background: url("~@/assets/images/bigDatanew/zhyg.png") no-repeat;
		background-size: 100% 100%;
	}

	.twoleftitem {
		width: 100%;
		height: 61px;
		background: url("~@/assets/images/bigData/obg8.png") no-repeat;
		background-size: 100% 100%;
		padding: 0px 12px;
		box-sizing: border-box;
		font-size: 14px;
		margin-bottom: 6px;
		// color:#02E0E9;
		color: #FFD70E;

		.twoleftone {
			height: 50px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #fff;
			font-size: 14px;

			>img {
				width: 24px;
				height: 24px;
				margin-right: 8px;
			}
		}
	}

	.ztboxs {
		height: auto;
		width: 100%;
		// background: linear-gradient(0deg, #001861 100%);
		// background:#001861;
		background: rgba(0, 24, 97, 0.5);
		border: 1px solid #075190;
		border-image: linear-gradient(0deg, #075190) 10 10;
		box-sizing: border-box;
		padding: 12px;

		.ztthree-item {
			width: 50%;
			height: 46px;
			box-sizing: border-box;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #fff;
			line-height: 23px;
			float: left;

			>img {
				width: 63px;
				height: 46px;
				margin-right: 10px;
			}

		}

		.ztrightone {
			width: 100%;
			height: 220px;
			background-color: #022775;
			padding: 12px;
			box-sizing: border-box;

			.ztrightone-twoitem {
				width: 50%;
				height: 70px;
				float: left;
				margin-top: 7px;
				background: url("~@/assets/images/bigData/obg47.png") no-repeat;
				background-size: 100% 100%;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				font-size: 14px;
				color: #fff;
				padding: 0px 28px;
				box-sizing: border-box;

				>img {
					width: 48px;
					height: 39px;
					margin-right: 16px;
				}

			}

			.ztrightoneitem {
				width: 100%;
				height: 50px;
				margin-bottom: 1px;
				background: url("~@/assets/images/bigData/obg30.png") no-repeat;
				background-size: 100% 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				color: #fff;
				padding: 0px 14px;
				box-sizing: border-box;

				.ztrightoneleft {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					font-size: 14px;
					color: #fff;

					>img {
						width: 26px;
						height: 32px;
						margin-right: 10px;
					}
				}
			}
		}

		.ztboxs-left {
			width: 100%;
			display: flex;
			justify-content: space-around;
			margin-top: 10px;

			.ztboxs-left-item {
				width: 84px;
				height: 67px;
				line-height: 20px;
				font-size: 14px;
				color: #fff;
				text-align: center;
				margin-bottom: 3px;
			}

			.ztboxs-left-img {
				width: 84px;
				height: 47px;
				line-height: 20px;
				font-size: 14px;
				color: #fff;
				text-align: center;
				background: url("~@/assets/images/bigData/obg28.png") no-repeat;
				background-size: 100% 100%;
			}
		}

		.ztboxs-right {
			width: 100%;
			height: 300px;
		}

		.brand-item {
			width: 100px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			// background: #1142C0;
			box-shadow: inset 0px 0px 12px 0px #089ED5;
			border-radius: 6px 6px 6px 6px;
			border: 1px solid #6281FF;
			margin-right: 20px;
		}

		.money-item {
			width: 180px;
			height: 50px;
			line-height: 50px;
			text-align: center;
			// background: #1142C0;
			box-shadow: inset 0px 0px 12px 0px #005aff;
			border: 1px solid #286DEC;
			margin-right: 20px;

			.money-num {
				color: #FFD70E;
				font-weight: bold;
				font-size: 16px;
			}
		}
	}

	.ztim {
		font-weight: bold;
		font-size: 18px;
		color: #FFD70E;
	}

	.zttwo {
		overflow: hidden;
		width: 100%;

		.zttwoitem {
			width: calc((100% - 30px)/3);
			// height:700px;
			height: 866px;

			.ztleftone {
				width: 100%;
				height: 340px;
				margin-bottom: 10px;

				.twoleftitem {
					width: 100%;
					height: 61px;
					background: url("~@/assets/images/bigData/obg8.png") no-repeat;
					background-size: 100% 100%;
					padding: 0px 12px;
					box-sizing: border-box;
					font-size: 14px;
					margin-bottom: 6px;
					// color:#02E0E9;
					color: #FFD70E;

					.twoleftone {
						height: 50px;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						color: #fff;
						font-size: 14px;

						>img {
							width: 24px;
							height: 24px;
							margin-right: 8px;
						}
					}
				}

				.twoleftitems {
					background: url("~@/assets/images/bigData/obg1.png") no-repeat;
					background-size: 100% 100%;
					// height:70px;
				}

				.twoleftcolor {
					color: #02E0E9;
				}

				.twoleftmiddle {
					width: 100%;
					height: auto;
				}

				.twoleftems {
					width: 100%;
					height: 58px;
					background: rgba(17, 66, 192, 0);
					box-shadow: inset 0px 0px 25px rgba(8, 158, 213, 0.4);
					//  box-shadow:  5px 5px 10px rgba(0, 0, 0, 0.5);
					border-radius: 6px 0px 0px 6px;
					border: 1px solid #6281FF;
					margin-bottom: 18px;
					display: flex;
					justify-content: flex-start;
					align-items: center;

					.twoleft-one {
						width: 92px;
						height: 58px;
						background: rgba(17, 66, 192, 0);
						box-shadow: inset 0px 0px 25pxrgba(8, 158, 213, 0.4);
						border-radius: 6px 0px 0px 6px;
						border-right: 1px solid #6281FF;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #fff;
						font-size: 14px;

						>img {
							width: 24px;
							height: 20px;
							margin-right: 5px;
						}
					}

					.twoleft-zt {
						width: calc(100% - 92px);
						height: 100px;
						display: flex;
						justify-items: flex-start;
						flex-wrap: wrap;
						align-items: center;
					}

					.twoleft-line {
						width: 1px;
						height: 20px;
						background: rgba(17, 66, 192, 0.4);
					}

					.twoleft-item {
						width: calc((100% - 94px)/3);
						height: 58px;
						box-sizing: border-box;
						text-align: center;
						padding: 9px 0px;
						box-sizing: border-box;

						.twoleft-item-text {
							font-size: 12px;
							line-height: 20px;
							height: 20px;
							color: #fff;
						}

						.twoleft-item-num {
							font-size: 16px;
							line-height: 20px;
							height: 20px;
							color: #FFD70E;
						}
					}
				}
			}

			.ztmiddone {
				width: 100%;
				// height: 317px;
				overflow: hidden;

				.ztmiddoneitem {
					// width: calc((100% - 10px)/2);
					width: 100%;
					height: 100%;
					// float: left;
					overflow: hidden;

					.zhubt {
						height: 50px;
						line-height: 50px;
						text-align: center;
						color: #fff;
						font-size: 16px;
						font-weight: 400;

						.zhucolor {
							color: #02E1E9;
							font-weight: bold;
						}
					}

					.zhudb {
						width: 100%;
						height: 178px;
						overflow: hidden;
						overflow-y: auto;
					}

					.zhuitem {
						width: 140px;
						height: 64px;
						background: url("~@/assets/images/bigData/tbg3.png") no-repeat;
						background-size: 100% 100%;
						text-align: center;
						line-height: 64px;
						color: #fff;
						font-size: 14px;
						margin: 0px auto 25px;
					}

					.rightitem {
						width: calc((100% - 10px)/2);
						height: 84px;
						padding: 12px 10px;
						background: rgba(0, 30, 71, 0);
						box-shadow: inset 0px 0px 25px rgba(8, 158, 213, 0.4);
						border-radius: 5px;
						border: 1px solid #247DD8;
						box-sizing: border-box;
						float: left;
						margin-top: 13px;
						margin-bottom: 13px;
						color: #fff;
						text-align: center;
						line-height: 30px;
						font-size: 14px;
						margin-right: 10px;
					}

					.rightitem:nth-child(2n) {
						margin-right: 0px;
					}

					.zttditem {
						width: 100%;
						height: 48px;
						background: url("~@/assets/images/bigData/obg27.png") no-repeat;
						background-size: 100% 100%;
						padding: 0px 15px;
						box-sizing: border-box;
						display: flex;
						justify-content: space-between;
						align-items: center;
						font-size: 14px;
						color: #fff;
					}
				}

				.ztmiddelthree {
					width: 100%;
					height: 115px;
					background: #022775;
					display: flex;
					justify-content: space-around;
					align-items: center;

					.everyitem {
						// width: 112px;
						width: 92px;
						height: 100%;
						padding: 10px 0px;
						box-sizing: border-box;

						.everyimg {
							width: 84px;
							height: 70px;
							background: url("~@/assets/images/bigData/obg24.png") no-repeat;
							background-size: 100% 100%;
							color: #fff;
							font-size: 14px;
							line-height: 70px;
							text-align: center;
							margin-left: 4px;

							.everynum {
								font-weight: bold;
								font-size: 20px;
								color: #FFD70E;
							}
						}

						.everytext {
							font-weight: 400;
							font-size: 14px;
							color: #FFFFFF;
							height: 22px;
							line-height: 22px;
							text-align: center;
						}
					}

					.ztmiddelthree-item {
						width: 109px;
						height: 115px;
						font-size: 14px;
						color: #fff;
						text-align: center;
						padding: 10px 0px;
						box-sizing: border-box;
						background: url("~@/assets/images/bigData/obg23.png") no-repeat;
						background-size: 100% 100%;

						.ztmiddelthree-num {
							font-weight: bold;
							font-size: 18px;
							color: #FFD70E;
							line-height: 32px;
							height: 32px;
						}

						.ztmiddelthree-text {
							line-height: 20px;
							height: 20px;
						}
					}
				}

				.ztbg {
					padding: 0px 6px;
					box-sizing: border-box;
					background-color: #022775;
					display: flex;
					justify-content: space-around;
					align-items: center;

					.ztbg-item {
						width: 45%;
						height: 80px;
						background: url("~@/assets/images/bigData/obg25.png") no-repeat;
						background-size: 100% 100%;
						padding: 10px 10px;
						box-sizing: border-box;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						// margin-top: 10px;

						.ztbg-img {
							width: 48px;
							height: 40px;
						}

						.ztbg-right {
							width: calc(100% -50px);
							height: 60px;
							padding: 10px 0px;
							box-sizing: border-box;
							line-height: 20px;
							font-size: 14px;
							color: #fff;

							.ztbg-rightnum {
								font-weight: bold;
								font-size: 18px;
								color: #FFD70E;
							}
						}
					}

					.ztbg-items {
						width: 33%;
						background: url("~@/assets/images/bigDatanew/bgt.png") no-repeat;
						background-size: 100% 100%;

						.ztbg-rights {
							width: 100%;
							text-align: center;
						}
					}
				}
			}
		}
	}
}

.ztlist::-webkit-scrollbar {
	height: 3px;
	/* 横向滚动条的高度 */
}

/* 滚动条轨道 */
.ztlist::-webkit-scrollbar-track {
	background: #010D40;
	/* 轨道背景色 */
	border-radius: 10px;
	/* 轨道圆角 */
}

/* 滚动条滑块 */
.ztlist::-webkit-scrollbar-thumb {
	background: #4973c6;
	/* 滚动条颜色 */
	border-radius: 10px;
	/* 滚动条圆角 */
}

/* 滚动条滑块悬停效果 */
.ztlist::-webkit-scrollbar-thumb:hover {
	background: #4973c6;
	/* 鼠标悬停时滚动条颜色 */
}

::v-deep .ant-select-selection {
	background-color: #01297d;
	color: #fff;
	border-color: #2669e6;
}

::v-deep .ant-select-dropdown {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-select-arrow {
	background-color: #01297d;
	color: #fff;
}

::v-deep .ant-radio-button-wrapper {
	color: #999;
	background-color: #0d308d;
	border-color: #ffffff00;
	border-radius: 0;
}
</style>

<style lang="scss">
.customClass {
	background: #01297d;

	.ant-select-dropdown-menu-item {
		background-color: #01297d;
		color: #fff;

		&:not(:last-child) {
			border-bottom: 1px solid #999;
		}

		&:hover:not(.ant-select-dropdown-menu-item-disabled) {
			background-color: #0f5bff;
		}
	}
}
</style>